export default __webpack_public_path__ + "imgs/wonder_logo_rebrand.08d130f3cd1ffba354970cd2334f5129.svg";